module.exports = __webpack_public_path__ + "static/media/show_chart.31da21fc.svg";